import { createDateObject, newUUID, statuses } from '@/core';

export default function() {
	return {
		id: newUUID(),
		tripId: undefined,
		legNumber: 0,
		fromAddress: {},
		toAddress: {},
		vendor: undefined,
		driver: undefined,
		status: statuses.trip.ready,
		needAccept: false,
		cargoCarrier: undefined,
		etd: createDateObject({ hasTime: false }),
		eta: createDateObject({ hasTime: false }),
		broadcastDrivers: [],
		wasSent: false,
	};
}
